import { useEffect, type ReactNode } from "react";
import { useAuth } from "../../../contexts/auth/Context";
import { useOnboardingStatus } from "../../../hooks/legal/useLegalDocuments";
import { ChangePasswordRequiredDialog } from "../auth/changePasswordRequiredDialog";
import { AcceptLegalDialog } from "../auth/acceptLegalDialog";

export const OnboardingGate = ({ children }: { children: ReactNode }) => {
  const {
    authenticated,
    mustChangePassword,
    mustAcceptTerms,
    syncOnboardingFromGate,
  } = useAuth();
  // Misma query que consume el diálogo: una sola petición y una sola verdad.
  const { data } = useOnboardingStatus();

  useEffect(() => {
    if (!data) return;
    syncOnboardingFromGate({
      mustChangePassword: data.mustChangePassword,
      mustAcceptTerms: data.mustAcceptTerms,
    });
  }, [data, syncOnboardingFromGate]);

  const gateActive = authenticated && (mustChangePassword || mustAcceptTerms);

  if (gateActive) {
    return (
      <div className="fixed inset-0 bg-global-primary">
        {mustChangePassword ? (
          <ChangePasswordRequiredDialog />
        ) : (
          <AcceptLegalDialog />
        )}
      </div>
    );
  }

  return <>{children}</>;
};
